export default __webpack_public_path__ + "static/media/solteirotriplo_4.3f801213.jpg";